import React from 'react';
import Sidebar from '../sidebar/Sidebar';
import Navbar from '../navbar/Navbar';
import './NotFound.scss'

const NotFound = () => (
    <div className="list">
        <Sidebar />
        <div className="listContainer">
            <Navbar />
            <div className='not-found'>
                <h1>404</h1>
                <h3>Page Not Found</h3>
            </div>

        </div>
    </div>
);
export default NotFound;